import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { HasPermissionDirective } from '../../../directives/permissions.directive';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-legacy-app-links',
  templateUrl: './legacy-app-links.component.html',
  styleUrls: ['./legacy-app-links.component.scss'],
  imports: [
    MatCardModule,
    HasPermissionDirective,
    MatButtonModule,
    MatIconModule,
    RouterLink,
  ],
})
export class LegacyAppLinksComponent {}
